/* ============================================================================
   LAH — RESERVA COM AGENDAMENTO DE CONSULTA
   Tema: Testes de implementacao (0.2)

   Guarda nome, WhatsApp, data da consulta, modelo e cor. O beneficio (filtro
   azul gratis) vale por 7 dias apos a consulta.

   VERSAO LOCAL: a reserva vive em localStorage. Sustenta toda a interface e
   permite testar a ideia sem integracao. Nao sobrevive a troca de navegador,
   nao alimenta icone no cabecalho e nao chega na Martz — para isso a reserva
   precisa criar um CLIENTE na Shopify, com as tags carregando o estado.

   O evento lah_reserva_criada no dataLayer ja leva tudo que sera preciso.
   ============================================================================ */

(function () {
    'use strict';

    var root = document.querySelector('[data-lah-reserva]');
    if (!root) return;

    var STORAGE_KEY = 'lah_reserva_' + root.getAttribute('data-produto-id');
    var JANELA = parseInt(root.getAttribute('data-janela-dias'), 10) || 7;

    var stepForm = root.querySelector('[data-lah-res-step="form"]');
    var stepDone = root.querySelector('[data-lah-res-step="done"]');
    var inputNome = root.querySelector('[data-lah-res-nome]');
    var inputFone = root.querySelector('[data-lah-res-fone]');
    var inputData = root.querySelector('[data-lah-res-data]');
    var erro = root.querySelector('[data-lah-res-erro]');

    function track(eventName, payload) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
        } catch (e) { /* analytics nunca deve quebrar a venda */ }
    }

    /* Data minima = hoje. Consulta no passado nao faz sentido, e permitir
       datas antigas abriria a porta para pegar o beneficio sem compromisso. */
    function hojeISO() {
        var d = new Date();
        var m = d.getMonth() + 1;
        var day = d.getDate();
        return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
    }

    if (inputData) inputData.min = hojeISO();

    function formatarBR(iso) {
        var partes = (iso || '').split('-');
        if (partes.length !== 3) return '';
        return partes[2] + '/' + partes[1] + '/' + partes[0];
    }

    function somarDias(iso, dias) {
        var partes = iso.split('-');
        /* Meio-dia evita que fuso horario empurre a data um dia para tras —
           erro classico com datas puras em JavaScript. */
        var d = new Date(partes[0], partes[1] - 1, partes[2], 12, 0, 0);
        d.setDate(d.getDate() + dias);
        var m = d.getMonth() + 1;
        var day = d.getDate();
        return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
    }

    function mascararFone(valor) {
        var d = (valor || '').replace(/\D/g, '').slice(0, 11);
        if (d.length <= 2) return d;
        if (d.length <= 6) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
        if (d.length <= 10) return '(' + d.slice(0, 2) + ') ' + d.slice(2, 6) + '-' + d.slice(6);
        return '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
    }

    if (inputFone) {
        inputFone.addEventListener('input', function () {
            inputFone.value = mascararFone(inputFone.value);
        });
    }

    function primeiroNome(nome) {
        return (nome || '').trim().split(/\s+/)[0] || '';
    }

    function mostrarErro(msg) {
        if (!erro) return;
        erro.textContent = msg;
        erro.hidden = false;
    }

    function limparErro() {
        if (erro) erro.hidden = true;
    }

    [inputNome, inputFone, inputData].forEach(function (el) {
        if (el) el.addEventListener('input', limparErro);
    });

    function ler() {
        try {
            var raw = window.localStorage.getItem(STORAGE_KEY);
            return raw ? JSON.parse(raw) : null;
        } catch (e) {
            return null;
        }
    }

    function gravar(dados) {
        try {
            window.localStorage.setItem(STORAGE_KEY, JSON.stringify(dados));
        } catch (e) { /* modo privado: a tela funciona, so nao persiste */ }
    }

    function apagar() {
        try {
            window.localStorage.removeItem(STORAGE_KEY);
        } catch (e) { /* ignora */ }
    }

    function pintarConfirmado(dados) {
        var elTitulo = root.querySelector('[data-lah-res-done-titulo]');
        var elVariante = root.querySelector('[data-lah-res-done-variante]');
        var elConsulta = root.querySelector('[data-lah-res-done-consulta]');
        var elValidade = root.querySelector('[data-lah-res-done-validade]');

        /* Chamar pelo primeiro nome faz a reserva parecer guardada para aquela
           pessoa, nao um registro qualquer — e a reciprocidade e metade do
           mecanismo. */
        var nome = primeiroNome(dados.nome);
        if (elTitulo) {
            elTitulo.textContent = nome
                ? nome + ', está tudo separado para você'
                : 'Está tudo separado para você';
        }

        if (elVariante) elVariante.textContent = dados.variante || '';
        if (elConsulta) elConsulta.textContent = formatarBR(dados.consulta);
        if (elValidade) elValidade.textContent = formatarBR(dados.validade);

        stepForm.hidden = true;
        stepDone.hidden = false;
    }

    /* ---- Salvar ---- */
    var btnSalvar = root.querySelector('[data-lah-res-salvar]');
    if (btnSalvar) {
        btnSalvar.addEventListener('click', function () {
            var nome = inputNome ? inputNome.value.trim() : '';
            var fone = inputFone ? inputFone.value.replace(/\D/g, '') : '';
            var data = inputData ? inputData.value : '';

            if (nome.length < 3) {
                mostrarErro('Informe seu nome.');
                if (inputNome) inputNome.focus();
                return;
            }

            if (fone.length < 10) {
                mostrarErro('Informe um WhatsApp com DDD.');
                if (inputFone) inputFone.focus();
                return;
            }

            if (!data) {
                mostrarErro('Informe a data da sua consulta.');
                if (inputData) inputData.focus();
                return;
            }

            if (data < hojeISO()) {
                mostrarErro('A data da consulta precisa ser hoje ou depois.');
                if (inputData) inputData.focus();
                return;
            }

            var varianteEl = root.querySelector('[data-lah-res-variante]');

            var dados = {
                nome: nome,
                whatsapp: fone,
                consulta: data,
                validade: somarDias(data, JANELA),
                produto: root.getAttribute('data-produto'),
                produto_id: root.getAttribute('data-produto-id'),
                produto_url: root.getAttribute('data-produto-url'),
                variante: varianteEl ? varianteEl.textContent.trim() : '',
                criada_em: new Date().toISOString()
            };

            gravar(dados);
            pintarConfirmado(dados);

            /* Payload pronto para a integracao. O telefone vai so em digitos,
               no formato que automacoes de WhatsApp costumam pedir. */
            track('lah_reserva_criada', {
                nome: dados.nome,
                whatsapp: dados.whatsapp,
                data_consulta: dados.consulta,
                data_validade: dados.validade,
                produto: dados.produto,
                produto_id: dados.produto_id,
                variante: dados.variante,
                beneficio: 'filtro_azul_gratis'
            });
        });
    }

    /* ---- Voltar para a compra ---- */
    var btnComprar = root.querySelector('[data-lah-res-comprar]');
    if (btnComprar) {
        btnComprar.addEventListener('click', function () {
            track('lah_reserva_retomada', {
                produto_id: root.getAttribute('data-produto-id')
            });

            var lens = document.querySelector('.openProductLens');
            if (lens) lens.click();
        });
    }

    /* ---- Cancelar ---- */
    var btnLimpar = root.querySelector('[data-lah-res-limpar]');
    if (btnLimpar) {
        btnLimpar.addEventListener('click', function () {
            apagar();
            stepDone.hidden = true;
            stepForm.hidden = false;
            track('lah_reserva_cancelada', {
                produto_id: root.getAttribute('data-produto-id')
            });
        });
    }

    /* ---- Estado inicial: reserva expirada volta ao formulario ---- */
    var existente = ler();
    if (existente && existente.validade >= hojeISO()) {
        pintarConfirmado(existente);
    } else if (existente) {
        apagar();
    }
})();
